// components/RatesDisplay.jsx — Widget taux de change temps réel
import { useState, useEffect } from 'react';
import api from '../services/api';

const KEY_PAIRS = [
  { from: 'EUR', to: 'XAF', label: '1 EUR' },
  { from: 'USD', to: 'XAF', label: '1 USD' },
  { from: 'CNY', to: 'XAF', label: '1 CNY' },
  { from: 'GBP', to: 'XAF', label: '1 GBP' },
];

export default function RatesDisplay({ compact = true }) {
  const [rates, setRates] = useState(null);
  const [fetchedAt, setFetchedAt] = useState(null);
  const [error, setError] = useState(false);

  const loadRates = () => {
    api.get('/currency/rates').then(r => {
      if (r.data?.rates) { setRates(r.data.rates); setFetchedAt(r.data.fetched_at); setError(false); }
    }).catch(() => setError(true));
  };

  useEffect(() => {
    loadRates();
    const timer = setInterval(loadRates, 3600000);
    return () => clearInterval(timer);
  }, []);

  if (error || !rates) return null;

  const fmtXAF = v => Math.round(v).toLocaleString('fr-FR');
  const timeStr = fetchedAt ? new Date(fetchedAt).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : '';

  if (compact) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', gap: 12, overflowX: 'auto',
        padding: '6px 0', scrollbarWidth: 'none',
      }}>
        {KEY_PAIRS.map(({ from, to, label }) => {
          const fromRate = rates[from];
          if (!fromRate) return null;
          const xafValue = from === 'XAF' ? 1 : (1 / fromRate);
          return (
            <div key={from} style={{
              display: 'flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap',
              padding: '4px 10px', background: '#0A0E1A', borderRadius: 20,
              border: '1px solid #1e2d45', flexShrink: 0,
            }}>
              <span style={{ fontSize: 13, color: '#6b7fa3', fontWeight: 500 }}>{label} =</span>
              <span style={{ fontSize: 13, color: '#00D4AA', fontWeight: 700 }}>
                {fmtXAF(xafValue)} FCFA
              </span>
            </div>
          );
        })}
        {timeStr && (
          <span style={{ fontSize: 10, color: '#444f6a', whiteSpace: 'nowrap', flexShrink: 0 }}>
            Mis à jour {timeStr}
          </span>
        )}
      </div>
    );
  }

  return (
    <div style={{
      background: '#111827', border: '1px solid #1e2d45', borderRadius: 14,
      padding: 16, marginBottom: 16,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#E8EDF5' }}>Taux de change</div>
        {timeStr && <div style={{ fontSize: 10, color: '#6b7fa3' }}>Mis à jour à {timeStr}</div>}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
        {KEY_PAIRS.map(({ from, to, label }) => {
          const fromRate = rates[from];
          if (!fromRate) return null;
          const xafValue = from === 'XAF' ? 1 : (1 / fromRate);
          return (
            <div key={from} style={{
              background: '#0A0E1A', borderRadius: 10, padding: '10px 12px',
              border: '1px solid #1e2d45',
            }}>
              <div style={{ fontSize: 11, color: '#6b7fa3', marginBottom: 4 }}>{label}</div>
              <div style={{ fontSize: 15, fontWeight: 700, color: '#00D4AA' }}>
                {fmtXAF(xafValue)} <span style={{ fontSize: 11, color: '#6b7fa3' }}>FCFA</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
